export const filterKeys = {
    DEFAULT: 'DEFAULT',
    ALPHABETICAL: 'ALPHABETICAL',
    RAISED_HAND: 'RAISED_HAND',
    VIDEO_OFF_FIRST: 'VIDEO_OFF_FIRST',
    AUDIO_OFF_FIRST: 'AUDIO_OFF_FIRST',
    ELSEWHERE: 'ELSEWHERE',
}
